import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { TooltipConfig } from '../../../models/ui-config';
import { TooltipPosition } from '../../enums/tooltip-position.enum';

@Component({
  selector: 'ra-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class TooltipComponent implements OnInit {
  @Input() tooltipDesc: string;
  @Input() tooltipPos: string = TooltipPosition.Right;
  @Input() styles = {};
  @Input() divStyles = {};
  @Input() tooltipText = '';
  @Input() tooltipClass = '';
  @Input() tooltipConfig?: TooltipConfig;
  get matTooltipClass() {
    return (this.tooltipClass || '') + ' custom-tooltip';
  }

  constructor() {}

  ngOnInit(): void {
    this.tooltipDesc = this.tooltipDesc || this.tooltipConfig?.tooltipDesc;
    this.tooltipPos = this.tooltipPos || this.tooltipConfig?.tooltipPos;
    this.styles = this.styles || this.tooltipConfig?.styles;
    this.divStyles = this.divStyles || this.tooltipConfig?.divStyles;
    this.tooltipText = this.tooltipText || this.tooltipConfig?.tooltipText;
    this.tooltipClass = this.tooltipClass || this.tooltipConfig?.tooltipClass;
  }
}
